import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SeamlessOnboardingDashboard from './SeamlessOnboardingDashboard';

const mapStateToProps = () => ({
  // Add any Redux state that the component needs
  // For example:
  // selectedTeam: selectedTeamSelector(state),
  // account: myAccountSelector(state),
  // license: licenseSelector(state),
});

const mapDispatchToProps = {
  // Add any actions that the component needs
  // For example:
  // selectTeamId,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SeamlessOnboardingDashboard)
);
